import moment from 'moment';
import {MechanicBookingType} from '@/views/timeline/services/booking.types';
import {TIMELINE_HTML_UTILS_INSTANCE} from '@/views/timeline/services/timeline-html.utils';
import {MechanicBookingToVisDataItemTransformer} from '@/views/timeline/services/mechanics/staticdata/mechanic-booking-to-vis-dataItem-transformer.service';

class MechanicBookingToVisDataItemSimplifiedTransformer extends MechanicBookingToVisDataItemTransformer {

    protected defineContent(input: MechanicBookingType) {
        return input.mechanicRestAvailability.hours() + 'h';
    }

    protected defineTitle(input: MechanicBookingType) {
        let title = '';

        const restInfo = TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPair(
            'Restzeit:',
            input.mechanicRestAvailability.hours() + ' Stunde(n)'
        );

        title += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPairsWrapper(restInfo, 'subtitle-2');

        for (const schedule of input.schedules) {
            let scheduleLine = '';

            const start = moment(schedule.start as Date).format('HH:mm');
            const end = moment(schedule.end as Date).format('HH:mm');
            scheduleLine += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPair(
                'Uhrzeit:',
                `${start} - ${end} Uhr`
            );
            scheduleLine += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPairMultiline(
                'Tätigkeit:',
                String(schedule.title)
            );
            const rawContent: any = schedule.raw?.event;
            if (rawContent) {
                scheduleLine += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPair(
                    'Kunde:',
                    rawContent.customer || ''
                );
                scheduleLine += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPairMultiline(
                    'Baustelle:',
                    rawContent.location
                );
            }

            title += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPairsWrapper(scheduleLine);
        }

        return title;
    }
}

const MECHANIC_BOOKING_TO_VIS_DATA_ITEM_SIMPLIFIED_TRANSFORMER_INSTANCE =
    new MechanicBookingToVisDataItemSimplifiedTransformer();

export {MECHANIC_BOOKING_TO_VIS_DATA_ITEM_SIMPLIFIED_TRANSFORMER_INSTANCE};
